import { Link } from "react-router-dom";
import { clinicInfo } from "../data";

export default function Gravide() {
  const heroImg = "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/kiropraktor-assens-gravid_1.jpg";
  const secondaryImg = "https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/assets/783a3379-7262-480b-b55e-1bf6fb783275/behandling-kiropraktor_3.png";

  const godeRaad = [
    "Lad andre støvsuge og vaske gulv!",
    "Hvil dig ofte",
    "Undgå at sidde i skrædderstilling eller med benene over kors",
    "Stå med lige vægt på begge ben",
    "Undgå tunge løft",
    "Undgå for lange skridt",
    "Tag et trappetrin ad gangen",
    "Læg en plastikpose på bilsædet og drej med samlede ben",
    "Læg en pude mellem benene, når du ligger på siden",
    "Brug silkenattøj og silkelagener for lettere at vende rundt i sengen"
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      {/* Breadcrumb */}
      <nav className="flex mb-8 text-sm text-brand-600 font-medium">
        <Link to="/" className="hover:text-brand-800">Forside</Link>
        <span className="mx-2">/</span>
        <span className="text-brand-900 font-semibold">Gravide</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        {/* Main Content (8 cols) */}
        <article className="lg:col-span-8 space-y-12 text-left">
          {/* Hero Image */}
          <div className="overflow-hidden rounded-3xl border border-brand-100 shadow-md">
            <img
              src={heroImg}
              alt="Kiropraktor Assens Gravid"
              className="w-full h-[450px] object-cover object-center"
            />
          </div>

          {/* Intro Section */}
          <div className="space-y-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-950 leading-tight">
              Gå til kiropraktor som gravid
            </h1>
            <h2 className="text-2xl font-bold font-display text-brand-800">
              Hvordan kan kiropraktik lindre graviditeten?
            </h2>
            <p className="text-lg text-brand-800 leading-relaxed">
              Har du brug for at gå til kiropraktor som gravid, tilbyder vi behandlinger, der kan lindre dine symptomer under forløbet. Klinikken ligger i Assens på Fyn, hvor vi hjælper kvinder med at opnå komfort og tryghed gennem deres forløb.
            </p>
            <div className="pt-2">
              <a
                href={clinicInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-brand-600 px-8 py-3.5 text-base font-semibold text-white shadow-md hover:bg-brand-700 transition-all duration-200 cursor-pointer"
              >
                Kontakt klinikken
              </a>
            </div>
          </div>

          {/* Section: Det er normalt at få ondt i ryggen */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Det er normalt at få ondt i ryggen under graviditeten
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Det kan være nødvendigt at gå til kiropraktor, når du er gravid. Selvom en graviditet er noget helt særligt, bliver kroppen udfordret på forskellige parametre. Som gravid kan vi give dig ro i kroppen og lindre typiske problemer og symptomer.
            </p>

            {/* Gode råd boks */}
            <div className="bg-brand-50/50 rounded-3xl p-8 border border-brand-100 space-y-4">
              <h3 className="text-xl font-bold text-brand-900 flex items-center gap-2">
                <i className="fa-light fa-sparkles text-brand-600" />
                Gode råd til ondt i bækkenet
              </h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-brand-800">
                {godeRaad.map((rad, idx) => (
                  <li key={idx} className="flex items-start gap-2.5">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-100 text-brand-700 text-xs font-semibold">
                      {idx + 1}
                    </span>
                    <span>{rad}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Section: Vi generer ikke babyen */}
          <div className="space-y-6 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Vi generer ikke babyen
            </h2>
            <p className="text-brand-800 leading-relaxed">
              Du skal ikke være bange eller nervøs for at gå til kiropraktor, når du er gravid. I vores klinik på Fyn er vi altid mere forsigtige, når vi undersøger og behandler gravide. Alt efter hvor langt du er henne i graviditeten, tager vi naturligvis hensyn til, hvor meget du kan bevæge dig, og hvordan du kan ligge på briksen.
            </p>
            <div className="pt-2">
              <Link
                to="/kvalitetssikring"
                className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-800 font-semibold text-sm transition-colors"
              >
                Læs om vores kvalitetssikring
                <i className="fa-solid fa-arrow-right text-xs" />
              </Link>
            </div>
          </div>

          {/* Section: Symptomer som gravid */}
          <div className="space-y-8 border-t border-brand-100 pt-8">
            <h2 className="text-2xl sm:text-3xl font-bold font-display text-brand-950">
              Symptomer som gravid
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-7 space-y-6">
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Undersøgelse og behandling</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Som nævnt er leddene løsere end normalt pga. hormonerne, og derfor reagerer de fleste godt på behandlingen, selvom den er meget blid. Som kiropraktor går vi individuelt til værks og lytter til dine behov som gravid. Det is for os vigtigt, at du har en god og behagelig oplevelse, som kan give dig ro i kroppen på længere sigt, så du kan nyde din graviditet.
                  </p>
                </div>

                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Smerter i lænd og bækken</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Det er nærliggende at tænke på bækkenløsning, når man som gravid oplever smerter i bækkenregionen, men det er heldigvis sjældent årsagen. De hormonelle forandringer under en graviditet gør ligamenterne løsere, så bækkenet kan udvides under fødslen. For at det kan være bækkenløsning, skal man både have ondt på forsiden og bagsiden af bækkenet.
                  </p>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Oftest er der ikke tale bækkenløsning, men problemer med ét af de tre led i bækkenet. Smerterne kan være jagende og endda gå ned i benene eller frem til lysken. Typisk vil det gøre ondt at sidde eller rejse sig fra en stol, og det er smertefuldt at vride sig og vende sig i sengen. Selvom der ikke er tale om bækkenløsning, kan det give mening at besøge en kiropraktor, når du er gravid med disse symptomer. Her kan en kiropraktor lindre og mindske smerter og ubehag ved graviditeten.
                  </p>
                </div>

                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-brand-900">Smerter mellem skulderbladene</h3>
                  <p className="text-brand-800 leading-relaxed text-sm">
                    Mange ændrer kropsholdning, når maven vokser, og tyngdepunktet ændres. Samtidig bliver der mere og mere, der fylder og trykker, og der bliver mere at bære på. Det er normalt, at det kan begynde at gøre ondt at trække vejret dybt. Derfor kan det være en god idé at opsøge en kiropraktor med denne slags ubehag under din graviditet.
                  </p>
                </div>
              </div>

              <div className="md:col-span-5 space-y-6">
                <div className="overflow-hidden rounded-2xl border border-brand-100 shadow-sm aspect-4/3">
                  <img
                    src={secondaryImg}
                    alt="Behandling af gravid hos kiropraktor"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="bg-brand-50 p-6 rounded-2xl border border-brand-100 text-center">
                  <p className="text-sm text-brand-900 font-semibold mb-3">Har du brug for hjælp?</p>
                  <a
                    href={clinicInfo.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full items-center justify-center rounded-full bg-brand-600 py-2.5 text-sm font-bold text-white shadow-xs hover:bg-brand-700 transition-colors cursor-pointer"
                  >
                    Kontakt klinikken her
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Sidebar (4 cols) */}
        <aside className="lg:col-span-4 space-y-8 text-left sticky top-24">
          {/* Booking Card */}
          <div className="rounded-3xl bg-brand-900 text-white p-8 shadow-lg space-y-6">
            <h3 className="text-xl font-bold font-display text-white">Bestil tid i dag</h3>
            <p className="text-sm text-brand-200 leading-relaxed">
              Døjer du med smerter eller nedsat bevægelighed? Bestil en tid online eller ring til os for en uforpligtende snak.
            </p>
            <div className="space-y-4 pt-2">
              <a
                href={clinicInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-center rounded-full bg-white py-3.5 text-sm font-bold text-brand-900 shadow-sm hover:bg-brand-50 transition-all duration-200 hover:scale-102 active:scale-98 cursor-pointer"
              >
                Bestil tid online
              </a>
              <a
                href={`tel:${clinicInfo.phone}`}
                className="flex w-full items-center justify-center rounded-full bg-brand-800 border border-brand-700 py-3.5 text-sm font-bold text-white hover:bg-brand-700 transition-colors cursor-pointer"
              >
                <i className="fa-solid fa-phone mr-2" />
                <span className="whitespace-nowrap">{clinicInfo.phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4")}</span>
              </a>
            </div>
          </div>

          {/* Opening Hours Card */}
          <div className="rounded-3xl bg-white border border-brand-100 p-8 shadow-xs space-y-6">
            <h3 className="text-lg font-bold font-display text-brand-950 border-b border-brand-100 pb-3">
              Åbningstider
            </h3>
            <div className="space-y-3 text-sm text-brand-800">
              {clinicInfo.openingHours.map((item) => (
                <div key={item.day} className="flex justify-between border-b border-brand-50 pb-1.5">
                  <span>{item.day}</span>
                  <span className="font-semibold text-brand-900">{item.hours}</span>
                </div>
              ))}
              <div className="pt-2 text-xs text-brand-600">
                <p className="font-semibold text-brand-800">Telefontider:</p>
                <p className="mt-1">{clinicInfo.telefontider}</p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
